<p class="graph"><progress max="100" value={{result.percentage}}> 70% </progress></p>
<div class="flex-main">
  <span class="answer">{{result.text === '' ? '?' : choice}}</span>
  <div style="white-space: nowrap;">
    <span class="voters">{{result.votes === null ? '?' : result.votes}} {{'POLL-FINISHED.RATURES' | translate}}</span>
    <span class="voters"> - </span>
    <span class="percentage">{{result.percentage === null ? '?' : result.percentage.toLocaleString() + " %"}}</span>
  </div>
</div>
<div class="spacer"></div>
